import * as React from 'react'
import { useTheme } from 'styled-components'
import { StoreProps } from '../../../../services/stores/casting.store'
import { geocodingGeodesicDistance } from '../../../../services/utils/geocoding.service'
import SelectableListComponent from '../../../shared/selectable-list.component'

export default function CastingRequiredPlaceServiceDeliveryLocationComponent ({ store, data: { city, serviceDeliveryLocation } }: StoreProps) {
  const theme = useTheme()

  const sortedLocations = store.getServiceDeliveryLocations()
    .map(sdl => ({ ...sdl, distance: geocodingGeodesicDistance(city, sdl) }))
    .sort((a, b) => a.distance - b.distance)
  
  return <SelectableListComponent
    data={ sortedLocations }
    name="castingServiceDeliveryLocations"
    value={ serviceDeliveryLocation }
    onChange={ val => { store.set({ serviceDeliveryLocation: val }); store.nextFocus({ closeOnMobile: true }) } }
    formatter={ sdl => <span>{ sdl.name } : { sdl.inline_address } <strong style={{ color: theme.colors.clr_1 }}>{ ` ${sdl.distance} km` }</strong></span> } />
}
